import type { RewardsHistoryEntity } from "./RewardsHistoryEntities";

export type RewardsHistoryQueryParams = {
    offset: number;
    locale: string;
};

export enum REWARDS_HISTORY_TYPES {
    reward = "reward",
    redeem = "redeem",
    tier = "tier",
    referrer = "referrer",
    referred = "referred",
    refund = "refund",
    expired = "expired",
    import = "import",
    manual = "manual",
}

export enum REWARDS_HISTORY_IMPORT_TYPES {
    point = "point",
    tier = "tier",
}

export type RewardsGroupedHistoryList = Array<{
    month: string;
    historyItems: RewardsHistoryEntity[];
}>;
